import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { Login } from '../../../../app/observation/model/login.model';
import { UnitTreeNode } from '../../../masterscreen/model/unit-tree.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { ObservationService } from '../../../observation/services/observation.service';
import { MasterRequest, PassRequestDashBoardFilter } from '../../../person-on-board/model/masterrequest.model';
import { PermitRecord } from '../../../shared/models/PermitRecord';
import { UserPermissionParameters } from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { PermitStatus, PermitToWorkConstantsService } from '../../services/permittowork-constants.service';
import { PermitToWorkService } from '../../services/permittowork.service';
import { PTWFilter } from '../model/PTWFilteer.model';

@Component({
  selector: 'ara-ptw-dashboard',
  templateUrl: './ptw-dashboard.component.html',
  styleUrls: ['./ptw-dashboard.component.css']
})
export class PtwDashboardComponent implements OnInit {
  @ViewChild('cm') contextMenu: ContextMenu;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean; }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean; }[];
  permitRecords: PermitRecord[] = [];
  hideFilter: boolean;
  hideSort: boolean;
  rowCount: number;
  pageSize: number = 1;
  itemPerPage: number = 50;
  pageIndex: number = 0;
  units: any[];
  locations: any[];
  permitTypes: any[];
  names: any[];
  status: any[] = [];
  loggedInUserJSON: any;
  unitList: any;
  unitTree: UnitTreeNode[];
  PTWId: number = 0;
  userPermissions: UserPermissionParameters;
  selectedUnit: number[] = [];
  selectedPermitType: number[] = [];
  selectedStatus: number[] = [];
  selectedLocation: number[] = [];
  ptwFromDate: Date = null;
  ptwToDate: Date = null;
  ptwFilter: PTWFilter;
  columnList: any[];
  jsonString: any;
  exportData: any[] = [];
  searchText: string = "";
  searchModified: boolean = false;
  locationList: any[];
  locationDetails: any;
  isPTWChecked: boolean = true;
  isPermitRequestsChecked: boolean;
  permitRequestForDataResponse: MasterRequest[] = [];
  passRequestDashBoardFilterData: PassRequestDashBoardFilter;
  PermitStatus: PermitStatus;
  noRecordsMsg: string;
  showPagination: boolean;
  selectedPermit: number;
  independentPermissions: any;
  contextItems: MenuItem[] = [];
  row: HTMLElement;
  disableExport: boolean = false;

  constructor(private baseService: BaseService, private masterscreenService: MasterscreenService,
    private PTWService: PermitToWorkService, private observationService: ObservationService, private notificationsService: NotificationsService) {
    let route = JSON.stringify(PermitToWorkConstantsService.PTWNavigation.InnerRoutes);
    this.routesFlag = JSON.parse(route);
    this.reportRoutes = PermitToWorkConstantsService.PTWNavigation.ReportRoutes;
    this.permitRecords = [];
    this.locations = [];
    this.permitTypes = [
      { label: 'Class A Red', value: 1, checked: true },
      { label: 'Class B Blue', value: 2, checked: true },
      { label: 'No Permit', value: 3, checked: true },
    ];
    this.selectedPermitType.push(1, 2, 3);
    this.getStatus();
  }
  ngOnInit(): void {
    this.contextItems = [
      {
        label: 'Open In New Tab',
        icon: 'fa-external-link-square',
        command: e => this.openPermit()
      }
    ];
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession("UserIndependentPermissions")
    );
    if (!this.independentPermissions.PTW_Add && !this.independentPermissions.PTW_Add_Unit && !this.independentPermissions.PTW_Admin && !this.independentPermissions.PTW_Admin_Unit) {
      for (let index = 0; index < this.routesFlag.length; index++) {
        if (this.routesFlag[index].routeName === 'Apply Permit') {
          this.routesFlag.splice(index, 1);
        }
      }
    }
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.getUnits();
    this.ptwFilter = new PTWFilter();

  }

  showContextMenu(permitRecord:any) {
    this.selectedPermit = permitRecord.permitId;
    this.selectedUnit = permitRecord.unitId;
  }
  openPermit() {
    window.open(
      "/ptw/raise-permit/" + this.selectedPermit+';unitId=' + this.selectedUnit,"_blank"
    );
    this.contextMenu.hide();
  }

  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      unitDetails.forEach((unit) => {
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked: true
        });
        this.selectedUnit.push(unit.UnitId)
      });
    }
    this.getLocations();
  }

  doneFilter() {
    this.searchModified = true;
    this.getPTWRequestData();
    this.hideFilter = false;
  }

  getPTWRequestData() {
    this.baseService.showRootLoader = true;
    if (!this.rowCount) {
      this.rowCount = this.itemPerPage * 2;
    }
    this.ptwFilter.PageSize = this.itemPerPage;
    this.ptwFilter.SearchText = this.searchText;
    this.ptwFilter.FromDate =
      this.ptwFromDate !== null
        ? new Date(this.ptwFromDate.setHours(0, 0, 0, 0))
        : this.ptwFromDate;
    this.ptwFilter.ToDate =
      this.ptwToDate !== null
        ? new Date(this.ptwToDate.setHours(23, 59, 59, 0))
        : this.ptwToDate;
    this.ptwFilter.Units = this.selectedUnit;
    this.ptwFilter.StatusId = this.selectedStatus;
    if (!this.ptwFilter.OrderdByColoumName) {
      this.ptwFilter.OrderdByColoumName = "PermitId";
    }
    if (!this.ptwFilter.OrderdBy) {
      this.ptwFilter.OrderdBy = "DESC"
    }
    this.ptwFilter.PermitType = this.selectedPermitType;
    this.ptwFilter.Locations = this.selectedLocation;
    this.ptwFilter.CurrentPage = this.pageSize;
    if (this.pageSize === 1) {
      this.ptwFilter.PageIndex = 0;
    } else {
      this.ptwFilter.PageIndex = ((this.pageSize * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((this.pageSize + 1) * this.itemPerPage);
    }
    this.ptwFilter.SelectAll = this.isPTWChecked;
    this.ptwFilter.UserId = this.loggedInUserJSON.UserId;
    const filter = JSON.parse(this.baseService.getFilterData('ptwFilter'));
    if (!this.searchModified && filter) {
      this.ptwFilter = filter;
      this.ptwFromDate = filter.FromDate === null ? filter.FromDate : new Date(filter.FromDate);
      this.ptwToDate = filter.ToDate === null ? filter.ToDate : new Date(filter.ToDate);
      this.selectedUnit = filter.Units;
      this.isPTWChecked = filter.SelectAll;
      this.unitList.forEach(element => {
        element.checked = this.selectedUnit.includes(element) ? true : false;
      });
      this.selectedStatus = filter.StatusId;
      this.status.forEach(element => {
        element.checked = this.selectedStatus.includes(element) ? true : false;
      });
      this.selectedLocation = filter.Locations;
      this.locationList.forEach(element => {
        element.checked = this.selectedLocation.includes(element) ? true : false;
      });
      this.selectedPermitType = filter.PermitType;
      this.permitTypes.forEach(element => {
        element.checked = this.selectedPermitType.includes(element) ? true : false;
      });
    }
    else {
      this.baseService.setFilterData('ptwFilter', JSON.stringify(this.ptwFilter));
    }
    this.ptwFilter.UserId = this.loggedInUserJSON.UserId;
    const apiRequest = {
      Model: this.ptwFilter,
    };
    this.PTWService.getPTWRequests(
      apiRequest,
      this.callbackMethodForGetPTWRequestsData.bind(this)
    );
  }

  callbackMethodForGetPTWRequestsData(response) {
    if (response.Success) {
      this.permitRecords = [];
      //BOC Pritesh
      if(response.Result.length > 0)
      {
      response.Result.forEach((element,index) => {
        if(element.Status ==='Draft' && element.CreatedBy !== this.loggedInUserJSON.UserId)  
        {
          response.Result.splice(index,1);
        }
      });
      }
       //EOC Pritesh
      let permitRecordList = response.Result;
      if (permitRecordList) {
        permitRecordList.forEach((record) => {
          this.permitRecords.push({
            permitId: record.PermitId,
            permitNo: record.PermitNumber,
            activityName: record.ActivityName,
            location: record.ExactLocation,
            permitType: record.PermitType,
            name: record.ApplicantName,
            contractorName: record.ContractorName,
            expiryDate: record.PermitDurationTo,
            status: record.Status,
            unitId: record.UnitId,
            ContractNumber: record.ContractNumber,
            ContractHolderName: record.ContractHolderName
          });
        });
      }
      if (this.permitRecords.length < this.itemPerPage) {
        this.rowCount = this.rowCount - this.itemPerPage;
      }

      if (this.ptwFilter.SelectAll && !this.searchModified) {
        this.selectAllPTWRequests(this.ptwFilter.SelectAll);
      } else if (this.searchModified) {
        this.ptwFilter.SelectAll = true;
        this.isPTWChecked = true;
        this.PTWService.setAllPTWRequestIds([]);
        this.selectAllPTWRequests(this.ptwFilter.SelectAll);
      } else {
        if (this.PTWService.getAllPTWRequestIds()) {
          this.permitRecords.forEach(record => {
            this.PTWService.getAllPTWRequestIds().forEach(element => {
              if (element.PermitId === record.permitId) {
                record.Checked = true;
                return;
              }
            });
          });
        }
      }
    }
    this.baseService.showRootLoader = false;
  }

  getLocations() {
    const login = new Login();
    login.CompanyId = 0;
    const apiRequest = {
      Model: {
        ...login,
        GetActiveLocations: false
      }
    };
    this.observationService.getLocationData(apiRequest, this.callbackMethodForGetLocationData.bind(this));
  }
  callbackMethodForGetLocationData(response) {
    this.locationList = [];
    if (response) {
      if (response.Success) {
        this.locationDetails = response.Result;

      }
    } else {
      this.locationDetails = JSON.parse(this.baseService.getItemFromSession("allLocations"));
    }
    this.locationDetails.forEach((location) => {
      location['checked'] = true;
      this.locationList.push(
        {
          'label': location.LocationName,
          'value': location.LocationId,
          'checked': true
        }
      );
      this.selectedLocation.push(location.LocationId);
    });
    this.getPTWRequestData();
  }

  resetFilter() {
    this.selectedUnit = [];
    this.unitList.forEach(element => {
      this.selectedUnit.push(element.value)
    });
    this.selectedStatus = [];
    this.status.forEach(element => {
      this.selectedStatus.push(element.value)
    });
    this.selectedLocation = [];
    this.locationList.forEach(element => {
      this.selectedLocation.push(element.value)
    });
    this.selectedPermitType = [];
    this.permitTypes.forEach(element => {
      this.selectedPermitType.push(element.value)
    });
    this.ptwToDate = null;
    this.ptwFromDate = null;
    this.ptwFilter.OrderdByColoumName = 'PermitId';
    this.ptwFilter.OrderdBy = 'DESC';
    this.searchModified = true;
    this.getPTWRequestData();
    this.onClickedOutside();
  }

  ascPtwExpiryDate() {
    this.ptwFilter.OrderdByColoumName = "PermitDurationTo";
    this.ptwFilter.OrderdBy = "ASC";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  descPtwExpiryDate() {
    this.ptwFilter.OrderdByColoumName = "PermitDurationTo";
    this.ptwFilter.OrderdBy = "DESC";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  ascPtwNumber() {
    this.ptwFilter.OrderdByColoumName = "PermitNumber";
    this.ptwFilter.OrderdBy = "ASC";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  descPtwNumber() {
    this.ptwFilter.OrderdByColoumName = "PermitNumber";
    this.ptwFilter.OrderdBy = "DESC";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  ascPtwName() {
    this.ptwFilter.OrderdByColoumName = "Name";
    this.ptwFilter.OrderdBy = "ASC";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  descPtwName() {
    this.ptwFilter.OrderdByColoumName = "Name";
    this.ptwFilter.OrderdBy = "DESC";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  searchData() {
    this.ptwFilter.SearchText = this.searchText;
    this.searchModified = true;
    this.getPTWRequestData();
  }
  clearSearch() {
    this.searchText = "";
    this.searchModified = true;
    this.getPTWRequestData();
  }
  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }

  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }

  selectAllPTWRequests(checked) {
    let selectedPTWRequests: StoredPTWRequests[] = [];
    this.permitRecords.forEach((element) => {
      if (checked) {
        element.Checked = true;
        let ptwElem: StoredPTWRequests = new StoredPTWRequests();
        ptwElem.PermitId = element.permitId;
        ptwElem.UnitId = element.unitId;
        // selectedPTWRequests = this.PTWService.getAllPTWRequestIds();
        // if (!selectedPTWRequests) {
        //   selectedPTWRequests = [];
        // }
        selectedPTWRequests.push(ptwElem);
        this.PTWService.setAllPTWRequestIds(selectedPTWRequests);
      } else {
        element.Checked = false;
        this.PTWService.setAllPTWRequestIds([]);
      }
    });
    this.ptwFilter.SelectAll = this.isPTWChecked;
    this.baseService.setFilterData(
      "ptwFilter",
      JSON.stringify(this.ptwFilter)
    );
  }
  exportToExcel() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const filter = JSON.parse(this.baseService.getFilterData('ptwFilter'));
    filter.SourceIds = [];
    this.PTWService.getAllPTWRequestIds().forEach(element => {
      filter.SourceIds.push(element.PermitId);
    });
    const apiRequest = {
      Model: filter
    };
    // Call dummy method to post data
    this.PTWService.exportToExcelPTWpermits(apiRequest, this.callbackMethodForexportToExcelPTWPermitsData.bind(this));
  }
  callbackMethodForexportToExcelPTWPermitsData(response) {
    if(response.Success){
      this.exportData = response.Result;
      this.columnList = [
        { key: "PermitNumber", value: "Permit Number" },
        { key: "PermitType", value: "Permit Type" },
        { key: "UnitName", value: "Unit" },
        { key: "ExactLocation", value: "Location" },
        { key: "ApplicantName", value: "Applicant Name" },
        { key: "PermitDurationTo", value: "Expiry Date" },
        { key: "WorkDescription", value: "Description" },
        { key: "Status", value: "Status" },
        { key: "ApplicantContractor", value: "Contractor Name" },
        { key: "ActivityName", value: "Activity Name" },
        { key: "ContractNumber", value: "Contractor Number" },
        { key: "ContractHolderName", value: "Contract Holder Name" }
      ];
      const parsedResponse: any = FileUtility.convertToCSV(this.exportData, this.columnList);
      FileUtility.downloadCSV(parsedResponse, 'PTWPermitsReport.csv');
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }

  selectPermitRequests(permitRecord, event) {
    let permitRecords = this.PTWService.getAllPTWRequestIds();
    if (event.target.checked) {
      permitRecords.push({ 'PermitId': permitRecord.permitId, 'UnitId': permitRecord.unitId });
      if (permitRecords.length === this.permitRequestForDataResponse.length) {
        this.isPermitRequestsChecked = true;
      }
    } else {
      this.isPermitRequestsChecked = false;
      this.ptwFilter.SelectAll = this.isPermitRequestsChecked;
      for (let index = 0; index < permitRecords.length; index++) {
        const element = permitRecords[index];
        if (permitRecord.permitId === element.PermitId) {
          permitRecords.splice(index, 1);
          break;
        }
      }
    }
    this.PTWService.setAllPTWRequestIds(permitRecords);
    this.baseService.setFilterData('ptwFilter', JSON.stringify(this.ptwFilter));
  }

  downloadZIP() {
    this.disableExport = true;
    this.notificationsService.toastNotify('info', 'Information Message', 'Downloading is in progress!');
    const permitRequestIds = [];
    this.PTWService.getAllPTWRequestIds().forEach(element => {
      permitRequestIds.push({
        ProcessName: 'PTW',
        SourceId: element.PermitId,
        UserId: this.loggedInUserJSON.UserId
      });
    });
    if (permitRequestIds.length > 0) {
      const apiRequest = {
        Model: {
          SourceIds: permitRequestIds
        }
      }
      this.PTWService.downloadZIP(apiRequest, this.callbackMethodForDownloadZIP.bind(this));
    }
  }

  callbackMethodForDownloadZIP(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = "zip_ptw_requests.zip"; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
    else{
      this.notificationsService.toastNotify(
        "error",
        "Error Message",
        "Something Went Wrong."
      );
    }
    this.disableExport = false;
  }
  downloadPDF(permitRequestId) {
    this.notificationsService.toastNotify('info', 'Information Message', 'Download is in Progress!');
    const apiRequest = {
      Model: {
        ProcessName: "PTW",
        SourceId: permitRequestId,
        UserId: this.loggedInUserJSON.UserId
      }
    };
    this.PTWService.downloadPDF(apiRequest, this.callbackMethodForDownloadPDF.bind(this));
  }

  callbackMethodForDownloadPDF(response) {
    //Here assign the Byte array returned from API to data variable
    var fileDownLoadName = "pdf_ptw.pdf"; //Here we can assign name of the document
    FileUtility.downloadPDF(response, fileDownLoadName);
  }


  getServerData(event) {
    this.PTWService.setcurrentPTWPageIndex(event);
    if (event === 1) {
      this.ptwFilter.PageIndex = 0;
    } else {
      this.ptwFilter.PageIndex = ((event * this.itemPerPage) - this.itemPerPage);
      this.rowCount = ((event + 1) * this.itemPerPage);
    }
    this.ptwFilter.CurrentPage = event;
    this.pageSize = event;
    this.searchModified = true;
    this.getPTWRequestData();
  }

  selectPTWRequest(observation, event) {
    let permits = this.PTWService.getAllPTWRequestIds();
    if (event.target.checked) {
      let obsElem: StoredPTWRequests = new StoredPTWRequests();
      obsElem.PermitId = observation.PermitId;
      obsElem.UnitId = observation.UnitId;
      permits.push(obsElem);
      if (permits.length === this.permitRecords.length) {
        this.isPTWChecked = true;
      }
    } else {
      this.isPTWChecked = false;
      this.ptwFilter.SelectAll = this.isPTWChecked;
      for (let index = 0; index < permits.length; index++) {
        const element = permits[index];
        if (observation.PermitId === element.PermitId) {
          permits.splice(index, 1);
          break;
        }
      }
    }
    this.PTWService.setAllPTWRequestIds(permits);
    this.baseService.setFilterData('ptwFilter', JSON.stringify(this.ptwFilter));
  }

  getStatus() {
    this.PTWService.getPTWStatus({}, this.callbackMethodForGetStatus.bind(this));
  }
  callbackMethodForGetStatus(response) {
    this.status = [];
    if (response) {
      if (response.Success) {
        response.Result.forEach(element => {
          if ((((this.independentPermissions.SUPER_Admin && element.StatusName == 'Cancelled') || (element.StatusName != 'Cancelled' && element.StatusName != 'Deleted')) ||
            ((this.independentPermissions.SUPER_Admin && element.StatusName == 'Deleted') || (element.StatusName != 'Deleted' && element.StatusName != 'Cancelled')))) {
            this.status.push(
              {
                'value': element.StatusId,
                'label': element.StatusName,
                'checked': true
              });
            this.selectedStatus.push(element.StatusId);
          }
        });
      }
    }
  }

  getCurrentDOMElementId(id) {
    this.PTWService.setcurrentPTWPageIndex(id);
    let permits = this.PTWService.getAllPTWRequestIds();
    if (!permits.filter(permit => {
      if (permit.permitId === id) {
        return permit;
      }
    })) {
      this.permitRecords.forEach(element => {
        if (element.permitId === id) {
          permits.push(element);
          return;
        }
      });
      this.PTWService.setAllPTWRequestIds(permits);
    }
  }

  getOutput(output) {
    if (output) {
      this.ngOnInit();
    } else {
      this.notificationsService.toastNotify('error', 'Error Message', 'Record is in use!');
    }
  }
}
export class StoredPTWRequests {
  PermitId: number;
  UnitId: number;
}
